import React from "react"
import { Typography } from "antd"

const { Text } = Typography

const Bold = ({ children }) => {
  return (
    <Text strong>{children}</Text>
  )
}

export default Bold